import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id B5AC4711-8218-4B94-9372-628616C5CBD8
 * name layers-triple-outline
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/layers-triple-outline.svg
 * tags
 */
export const LayersTripleOutlineIcon = createSvgIcon(<><path d="M12 16.54L19.37 10.8L21 12.07L12 19.07L3 12.07L4.62 10.81L12 16.54M12 14L3 7L12 0L21 7L12 14M12 2.53L6.26 7L12 11.47L17.74 7L12 2.53M12 21.47L19.37 15.73L21 17L12 24L3 17L4.62 15.74L12 21.47" /></>, 'LayersTripleOutlineIcon');
export default LayersTripleOutlineIcon